import { CAPTURE_ALWAYS_REQUIRED_FIELDS, CAPTURE_CONDITIONAL_FIELDS } from './aiAttendantEngine';

export const CAPTURE_CHECKLIST_FIELDS = ['pickup_location', 'dropoff_location', 'date', 'time', 'passenger_count', 'luggage_count', ...CAPTURE_CONDITIONAL_FIELDS];

export function captureChecklistFields(checklist = {}) {
    if (!checklist.service_type) return CAPTURE_CHECKLIST_FIELDS;
    return [...new Set([...CAPTURE_ALWAYS_REQUIRED_FIELDS, ...CAPTURE_CONDITIONAL_FIELDS,
        ...Object.keys(checklist).filter((field) => checklist[field]?.required)])];
}

export function captureChecklistStats(checklist = {}) {
    const fields = captureChecklistFields(checklist);
    const captured = fields.filter((field) => Boolean(checklist?.[field]?.captured)).length;
    const total = fields.length;
    const percent = total > 0 ? Math.round((captured / total) * 100) : 0;
    const missingRequired = fields.filter((field) => {
        const item = checklist?.[field];
        const required = item?.required ?? (checklist.service_type
            ? CAPTURE_ALWAYS_REQUIRED_FIELDS.includes(field) : CAPTURE_CHECKLIST_FIELDS.includes(field));
        return required && !item?.captured;
    }).length;
    return { captured, total, percent, missingRequired };
}

export function checklistTierColor(percent = 0) {
    const value = Number(percent);
    const safePercent = Number.isFinite(value) ? value : 0;
    if (safePercent <= 20) return 'var(--ui-alert)';
    if (safePercent <= 40) return 'var(--ui-moderate)';
    if (safePercent <= 60) return 'var(--ui-gold)';
    if (safePercent <= 80) return 'var(--ui-positive)';
    return 'var(--ui-excellent)';
}

export function formatCaptureChecklistPill(checklist = {}) {
    const stats = captureChecklistStats(checklist);
    return `Checklist ${stats.captured}/${stats.total} · ${stats.percent}%`;
}
